import React from 'react';
import { styled } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  marginTop: 10,
  backgroundColor: theme.palette.background.paper,
  flex: 1,
}));

const Row = styled('div')({
  height: 35,
  marginBottom: 7,
});

const TableLoading: React.FC = () => {
  return (
    <Container>
      <Row className="animated-background" />
      <Row className="animated-background" />
      <Row className="animated-background" />
      <Row className="animated-background" />
    </Container>
  );
};

export default TableLoading;
